import React from "react"
import OpportunitySearchContainer from "../../containers/OpportunitySearchContainer"

const OpportunitySearchPage = () => {
  return <OpportunitySearchContainer />
}

export default OpportunitySearchPage
